var vLSCont_ = "cont_";
const vF106 = function (p17811, p17812, p17813) {
  this.active = false;
  this.state = false;
  this.name = p17811;
  this.altName = p17811 + "_alt";
  this.def = p17812;
  this.altDef = p17813;
  this.val = parseInt(getSavedVal(vLSCont_ + this.name) || this.def);
  this.altVal = parseInt(getSavedVal(vLSCont_ + this.altName) || this.altDef);
};
vF106.prototype.trigger = function (p17814) {
  if (p17814 !== this.state) {
    this.active = this.state = p17814;
  }
};
vF106.prototype.isKey = function (p17815) {
  return p17815 == this.val || p17815 == this.altVal;
};
vF106.prototype.isPressed = function () {
  return this.active;
};
vF106.prototype.reset = function (p17816) {
  this.update(p17816 ? this.altDef : this.def, ~~p17816);
};
vF106.prototype.resetAll = function () {
  this.update(this.def, 0);
  this.update(this.altDef, 1);
};
vF106.prototype.update = function (p17817, p17818) {
  if (p17818) {
    this.altVal = parseInt(p17817);
  } else {
    this.val = parseInt(p17817);
  }
  saveVal(vLSCont_ + (p17818 ? this.altName : this.name), p17817);
};
vF106.prototype.unbind = function (p17819) {
  this.update(-1, p17819);
};
module.exports = vF106;
var v13894 = typeof Storage != "undefined";
try {
  window.localStorage.canStore = true;
} catch {
  v13894 = false;
}
window.saveVal = (p17820, p17821) => {
  if (v13894) {
    localStorage.setItem(p17820, p17821);
  }
};
function f2146(p17822) {
  if (v13894) {
    localStorage.removeItem(p17822);
  }
}
window.getSavedVal = p17823 => v13894 ? localStorage.getItem(p17823) : null;